<div *ngIf="roots.length > 0" class="treeview">  
    <ul class="list-group">       
      <tree-node-simple 
                 *ngFor="let r of roots" 
                 [node]="r"
                 [activeNodeId]="activeNodeId"
                 [imageSet]="imageSet"                 
                 ></tree-node-simple>                                      
    </ul>
</div>